(() => {
  const managerKey = '__treyaProductHeroManager';

  if (window[managerKey]) {
    window[managerKey].initAll(document);
    return;
  }

  const instances = new Map();

  const init = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.treyaHeroInitialized === 'true') return;

    const sticky = root.querySelector('[data-treya-sticky-cart]');
    const stickyPrice = sticky?.querySelector('[data-treya-sticky-price]');
    const stickySubmit = sticky?.querySelector('[data-treya-sticky-submit]');
    const questionVariant = document.querySelector('[data-treya-selected-variant]');
    const mainSubmit = () => root.querySelector('.product-form__submit[name="add"]');
    const variantInput = () => root.querySelector('form[action*="/cart/add"] input[name="id"]');
    const priceSource = () => root.querySelector('[id^="price-"] .price');
    let animationFrame = null;

    const setText = (element, value) => {
      if (element && element.textContent !== value) element.textContent = value;
    };

    const sync = () => {
      animationFrame = null;
      const submit = mainSubmit();
      if (stickySubmit instanceof HTMLButtonElement && submit instanceof HTMLButtonElement) {
        stickySubmit.disabled = submit.disabled;
        const label = submit.querySelector('span')?.textContent?.trim() || (submit.disabled ? 'Sold out' : 'Add to cart');
        setText(stickySubmit.querySelector('span'), label);
      }

      const currentPrice = priceSource()?.textContent?.trim();
      if (stickyPrice && currentPrice) setText(stickyPrice, currentPrice);

      const currentVariant = variantInput()?.value || '';
      if (questionVariant && questionVariant.value !== currentVariant) questionVariant.value = currentVariant;
    };

    const scheduleSync = () => {
      if (animationFrame !== null) return;
      animationFrame = requestAnimationFrame(sync);
    };

    const submit = mainSubmit();
    const price = priceSource();
    const submitObserver = submit ? new MutationObserver(scheduleSync) : null;
    const priceObserver = price ? new MutationObserver(scheduleSync) : null;
    let intersectionObserver = null;

    submitObserver?.observe(submit, { attributes: true, childList: true, subtree: true });
    priceObserver?.observe(price, { childList: true, subtree: true, characterData: true });

    if (sticky && submit && !window.Shopify?.designMode) {
      intersectionObserver = new IntersectionObserver(([entry]) => {
        if (!entry) return;
        const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        sticky.dataset.visible = String(visible);
        sticky.setAttribute('aria-hidden', String(!visible));
      });
      intersectionObserver.observe(submit);
    } else if (sticky) {
      sticky.dataset.visible = 'false';
      sticky.setAttribute('aria-hidden', 'true');
    }

    const onStickySubmit = () => {
      const currentSubmit = mainSubmit();
      if (currentSubmit instanceof HTMLButtonElement && !currentSubmit.disabled) currentSubmit.click();
    };
    const onChange = () => scheduleSync();

    stickySubmit?.addEventListener('click', onStickySubmit);
    root.addEventListener('change', onChange);
    root.dataset.treyaHeroInitialized = 'true';
    sync();

    instances.set(root, () => {
      if (animationFrame !== null) cancelAnimationFrame(animationFrame);
      intersectionObserver?.disconnect();
      submitObserver?.disconnect();
      priceObserver?.disconnect();
      stickySubmit?.removeEventListener('click', onStickySubmit);
      root.removeEventListener('change', onChange);
      delete root.dataset.treyaHeroInitialized;
    });
  };

  const initAll = (scope) => {
    if (scope.matches?.('product-info.treya-product-hero')) init(scope);
    scope.querySelectorAll?.('product-info.treya-product-hero').forEach(init);
  };

  const destroyWithin = (scope) => {
    instances.forEach((destroy, root) => {
      if (root === scope || scope.contains?.(root)) {
        destroy();
        instances.delete(root);
      }
    });
  };

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

  window[managerKey] = { initAll, destroyWithin };
  initAll(document);
})();
